import { useState, SyntheticEvent } from 'react'
import { TabDepartment } from '../../pages/organizationChart/pages/departments/typing'
const useTabs = (data?: { defaultValue?: string }) => {
  const [value, setValue] = useState(TabDepartment.DEPARTMENT)

  const handleChange = (_: SyntheticEvent | null, newValue: TabDepartment) => {
    setValue(newValue)
  }

  return { handleChange, value }
}

export { useTabs }
